import {Header, LineChart} from '../../components'

const Line = () => {
  return (
    <div className='m-4 md:m-10 mt-24 p-10 bg-white dark:bg-secondary-dark-bg rounded-3xl drop-shadow-sm'>
      <Header category='Chart' title='Inflation Rate'/>
      <div className='w-auto'>
        <LineChart/>
      </div>
    </div>
  )
}

export default Line